import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import Icon from "../icon/icon";
import styles from "./buttons-group.module.scss";

const ButtonsGroup = ({
  label,
  options,
  disabled: primaryDisabled = false,
  loading: primaryLoading = false,
  handleClick,
  defaultSelect = 0,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(defaultSelect);
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const isDisabled = primaryDisabled || primaryLoading;

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);

  const handleMenuItemClick = (index) => {
    if (isDisabled) return;

    setSelectedIndex(index);
    setOpen(false);
    handleClick(index);
  };

  const toggleMenu = () => {
    if (!isDisabled) {
      setOpen((prevOpen) => !prevOpen);
    }
  };

  const buttonLabel = label || options?.[selectedIndex];

  return (
    <div
      ref={wrapperRef}
      className={classnames(styles.expwrap, { [styles.open]: open })}
    >
      <button
        type="button"
        className={styles.exp}
        onClick={toggleMenu}
        disabled={isDisabled}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        {primaryLoading && <Icon className="mr-sm" loading fontSize="14px" paddingless={true} />}
        {buttonLabel}
        <svg className={styles.ecaret} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      <div className={styles.expmenu} role="menu">
        {options.map((option, index) => (
          <button
            key={option}
            type="button"
            className={styles.expitem}
            onClick={() => handleMenuItemClick(index)}
            disabled={isDisabled}
            role="menuitem"
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ButtonsGroup;
